import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import VerificationInput from "react-verification-input";
import { useVerifyMutation, useGenerateMutation } from "../store";
import { VerificationTokenType } from "../types";
import Logo from "../components/common/Logo";
import { showToast, ToastType } from "../utils/toast.utils";

const CodeVerification = () => {
  const [verifyCode] = useVerifyMutation();
  const [generateCode] = useGenerateMutation();
  const [verificationType, setVerificationType] =
    useState<VerificationTokenType>(VerificationTokenType.VERIFY_EMAIL);

  const [email, setEmail] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    // Get code from the query string
    const urlParams = new URLSearchParams(window.location.search);
    const emailParam = urlParams.get("email");
    const verificationTypeParam = urlParams.get("type");
    if (verificationTypeParam)
      setVerificationType(verificationTypeParam as VerificationTokenType);
    if (emailParam) {
      setEmail(emailParam);
    } else {
      navigate("/");
    }
  }, [navigate]);

  const handleOnComplete = async (value: string) => {
    const data = {
      email,
      type: verificationType,
      token: value,
    };

    const result = await verifyCode(data);
    if (!result.error) {
      if (verificationType === VerificationTokenType.VERIFY_EMAIL) {
        navigate("/auth/login");
      } else if (verificationType === VerificationTokenType.RESET_PASSWORD) {
        navigate(`/auth/reset-password?email=${email}&code=${value}`);
      }
    }
  };

  const handleSendCode = async () => {
    const data = {
      email,
      type: verificationType,
    };

    const result = await generateCode(data);
    if (!result.error) {
      showToast("Code envoyé", ToastType.SUCCESS);
    }
  };

  return (
    <div className="w-full flex min-h-screen">
      <div className="w-full md:w-1/2 h-full flex flex-col items-center mt-12 gap-3 p-4">
        <Logo />
        <div>
          Saisissez le code reçu à l&apos;adresse{" "}
          <span className="font-semibold"> {email} </span> pour la valider
        </div>
        <VerificationInput
          autoFocus
          onComplete={handleOnComplete}
          validChars="0-9"
        />
        <div className="justify-start">
          Vous n&apos;avez pas reçu de code ?{" "}
          <span
            className="underline font-semibold cursor-pointer decoration-primary/75"
            onClick={handleSendCode}
          >
            envoyer à nouveau
          </span>
        </div>
      </div>
      <img
        className="hidden md:block w-1/2 min-h-screen h-auto object-cover"
        src="/assets/images/auth-banner.jpg"
      />
    </div>
  );
};

export default CodeVerification;
